import { DialectSdkError } from '@dialectlabs/sdk';
import { useCallback, useState } from 'react';
import useSWR, { useSWRConfig } from 'swr';
import { EMPTY_ARR } from '../utils';
import { isAdminable, isWritable } from '../utils/scopes';
import { CACHE_KEY_THREADS, CACHE_KEY_THREAD_FN } from './internal/swrCache';
import useDialectSdk from './useDialectSdk';
const useThread = ({ findParams, refreshInterval, }) => {
    const { mutate: globalMutate } = useSWRConfig();
    const { threads: threadsApi } = useDialectSdk();
    const [isDeletingThread, setIsDeletingThread] = useState(false);
    const [errorDeletingThread, setErrorDeletingThread] = useState(null);
    const { data: thread, error: errorFetchingThread, mutate: mutateThread, } = useSWR(CACHE_KEY_THREAD_FN(findParams), () => threadsApi.find(findParams), {
        refreshInterval,
        refreshWhenOffline: true,
    });
    const deleteThread = useCallback(async () => {
        if (!thread)
            return;
        setIsDeletingThread(true);
        setErrorDeletingThread(null);
        try {
            const result = await thread.delete();
            mutateThread();
            globalMutate(CACHE_KEY_THREADS);
            return result;
        }
        catch (e) {
            if (e instanceof DialectSdkError) {
                setErrorDeletingThread(e);
            }
            throw e;
        }
        finally {
            setIsDeletingThread(false);
        }
    }, [globalMutate, mutateThread, thread]);
    return {
        // sdk
        thread: thread || null,
        delete: deleteThread,
        // react-lib
        isFetchingThread: thread === undefined && !errorFetchingThread,
        errorFetchingThread,
        isDeletingThread,
        errorDeletingThread,
        isWritable: isWritable((thread === null || thread === void 0 ? void 0 : thread.me.scopes) || EMPTY_ARR),
        isAdminable: isAdminable((thread === null || thread === void 0 ? void 0 : thread.me.scopes) || EMPTY_ARR),
    };
};
export default useThread;
//# sourceMappingURL=useThread.js.map